// Mobile bottom tab bar — 3–5 thumb-reachable primary destinations, phone-only (≤640px via CSS).
// Generic like Segmented/DataTable: the caller supplies `items` and the `active` key.
// "More"-style actions pass an active key that matches no item, so nothing shows as current.
export default function TabBar({ items = [], active, className = '', ...rest }) {
  return (
    <nav className={`cn-tabbar ${className}`.trim()} aria-label="Primary" {...rest}>
      {items.map((it) => {
        const isActive = it.key === active
        return (
          <button
            key={it.key}
            type="button"
            className="cn-tabbar-item"
            data-active={isActive ? 'true' : 'false'}
            aria-current={isActive ? 'page' : undefined}
            onClick={it.onSelect}
          >
            <span className="cn-tabbar-icon" aria-hidden="true">{it.icon}</span>
            <span className="cn-tabbar-label">{it.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
